import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { DRAWER_WIDTH } from "src/assets/data/initialData";

export const FooterBox = styled(Box)`
  /* width: calc(100% - ${DRAWER_WIDTH + 34}px); */
  /* margin-inline-end: ${DRAWER_WIDTH + 26}px; */
  position: relative;
  /* margin-top: ${({ theme }) => theme.spacing(1.5)};
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};
  margin-inline-end: ${({ theme }) => theme.spacing(1.5, 0)}; */
  background-color: ${({ theme }) => theme.palette.grey.gb};
  /* padding: ${({ theme }) => theme.spacing(1)}; */
  width: 100%;
  min-height: 48px;
  background-clip: padding-box !important;
  border: 2px solid transparent;
  border-radius: 999px !important;
  z-index: 0;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -2px !important;
    border-radius: inherit !important;
    background: ${({ theme }) => theme.palette.gradients.secondary};
  }
`;
